import { ContentFormat } from '@/domain/models/content/content-format'
import { Subtype } from '@/domain/models/content/subtype'

export interface EnrollmentEngagementResponse {
  name: string
  institutionName: string
  subTypeId: string | null
  format: string | null
  step: number
  workflow: string
  cancellationDate: string | null
  orderId: number
  coursePrice: number
  courseCategoryId: number
  coursePlan: number
}

export interface EnrollmentEngagementData {
  name: string
  institutionName: string
  subtype: Subtype.Enum | null
  format: ContentFormat.Enum | null
  step: number
  workflow: EngagementWorkflow | null
  cancellationDate: Date | null
  orderId: number
  coursePrice: number
  courseCategoryId: number
  coursePlan: number
}

export enum EngagementWorkflow {
  ACTIVATION = 'activation',
  RETENTION = 'retention'
}

export enum SelectedEngagementOption {
  ALREADY_STUDYING = 'ALREADY_STUDYING',
  RESUME_STUDYING = 'RESUME_STUDYING',
  FINISHED_STUDYING = 'FINISHED_STUDYING',
  LOGIN = 'LOGIN'
}

export interface ConfirmEngagementRequest {
  source: SelectedEngagementOption
}
